import { IWalletEvent, IWalletEventMetadata, IWalletEventTicketCode } from 'meta/pages/v4/wallet'

type TicketsCodePageState = {
  items: Array<IWalletEventTicketCode>
  metadata: IWalletEventMetadata
}

type TicketsCodesState = {
  codes: Record<string, TicketsCodePageState>
}

export type WalletState = {
  events: {
    past: Record<number, Array<IWalletEvent>>
    upcoming: Record<number, Array<IWalletEvent>>
    tickets: TicketsCodesState
    metadata: {
      past: IWalletEventMetadata
      upcoming: IWalletEventMetadata
    }
  }

  goodsServices: {
    past: Record<number, Array<IWalletEvent>>
    upcoming: Record<number, Array<IWalletEvent>>
    metadata: {
      past: IWalletEventMetadata
      upcoming: IWalletEventMetadata
    }
  }
}

export const initialState: WalletState = {
  events: {
    past: {},
    upcoming: {},
    tickets: {
      codes: {},
    },
    metadata: {
      past: {
        currentPage: 0,
        hasMorePages: true,
      },
      upcoming: {
        currentPage: 0,
        hasMorePages: true,
      },
    },
  },
  goodsServices: {
    past: {},
    upcoming: {},
    metadata: {
      past: {
        currentPage: 0,
        hasMorePages: true,
      },
      upcoming: {
        currentPage: 0,
        hasMorePages: true,
      },
    },
  },
}
